"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSize = exports.classes = void 0;
var classes = {
  buttonGroup: 'bds-btn-group',
  buttonGroupChild: 'bds-btn-group-child'
};
exports.classes = classes;
var defaultSize = 'medium';
exports.defaultSize = defaultSize;